import * as React from "react"
import { cn } from "lib/utils"
import { ShortText } from "components/ShortTitle";

interface InputProps extends React.ComponentProps<"input"> {
  label?: string;
  labelClassName?: string;
}

function Input({ className, type, label, labelClassName, id, onChange, ...props }: InputProps) {
  const generatedId = React.useId();
  const inputId = id || generatedId;

  // حالة داخلية لعرض القيمة اللحظية بجانب الـ Label (خاصة للـ range)
  const [currentValue, setCurrentValue] = React.useState(props.defaultValue || props.value || "");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(e.target.value); // تحديث القيمة المعروضة
    if (onChange) onChange(e); // تمرير الحدث للأعلى (لتحديث Three.js)
  };

  return (
    <div className={`relative ${type === "range" && label ? " flex flex-row gap-2 items-center " : ""}  my-1 w-full `}>
      {(label || type === "range") && (
        <div
          className={cn(
            " start-1 flex items-center gap-2 px-1 tracking-wider font-bold select-none transition-colors group-focus-within:text-primary",
            (type === "range" && !label) && " translate-y-2 ",
            labelClassName
          )}
        >
          {label && <label
            // title={label}
            htmlFor={inputId}
            className="text-[11px]  text-primary-700 group-focus-within:text-primary"
          >
            <ShortText text={label} length={6} />

            {/* {label} */}
          </label>}

          {/* إظهار القيمة فقط إذا كان النوع range */}
          {type === "range" && (
            <input
              title={Number(currentValue).toFixed(2)}
              className=" text-xs px-1 rounded    w-full outline-none "
              type="number"
              value={Number(currentValue).toFixed(2)}
              onChange={handleInputChange}
            />

          )}
        </div>
      )
      }

      <input
        id={inputId}
        type={type}
        data-slot="input"
        onChange={handleInputChange}
        className={cn(
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
          "dark:bg-input/20 border-input flex h-10 w-full min-w-0 rounded-lg border bg-transparent px-3 py-1 text-base shadow-xs transition-all outline-none",
          "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          // "focus-visible:border-primary/50 focus-visible:ring-primary/30 focus-visible:ring-[3px] focus-visible:bg-primary/5",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          "bg-white dark:bg-[#1a1a1a]",
          className
        )}
        {...props}
      />
    </div >
  )
}

export { Input }